import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const PaginationWrapper = styled.div`
    padding-top: ${getPurpurSpacing('300')};
    padding-bottom: ${getPurpurSpacing('300')};
`;

export const PaginationCount = styled.div`
    margin: 0 auto ${getPurpurSpacing('300')};
    width: fit-content;
`;
